import { useEffect, useState } from "react"
import { loadStripe } from "@stripe/stripe-js"

export const useStripe = key => {
  const [stripe, setStripe] = useState(null)

  useEffect(() => {
    loadStripe(key).then(loadedStripe => {
      setStripe(loadedStripe)
    })
  }, [])

  return stripe
}
